import React, { Component } from "react"
import * as Icon from "react-feather"
import { Helmet } from "react-helmet"
import fetch from "cross-fetch"
import queryString from "query-string"
import _ from "lodash"

import Tag from "../tag"
import Loader from "../loader"

import avatar from "../../assets/images/avatar.svg"
import SbImageService, { isSvg } from "../../helpers/SbImageService"

class Profile extends Component {
  state = {
    loading: true,
    found: false,
    faculty: {},
  }

  componentDidMount() {
    if (typeof window !== "undefined") {
      const query = queryString.parse(window.location.search)
      const id = query.cid

      if (id) {
        fetch(`${process.env.GATSBY_HULTEDUDATA_API}/faculty/${id}`, {
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((res) => {
            if (res.status >= 400) {
              throw new Error("Bad response from server")
            }
            return res.json()
          })
          .then((result) => {
            this.setState({
              loading: false,
              found: result.found,
              faculty: result._source,
            })
          })
          .catch((err) => {
            console.error(err)
            this.setState({
              loading: false,
            })
          })
      }
    }
  }

  render() {
    const { loading, faculty } = this.state

    if (loading) {
      return <Loader />
    }

    return (
      <>
        {(faculty.FirstName || faculty.LastName) && (
          <Helmet
            title={`${faculty.FirstName} ${faculty.LastName} | Faculty | Hult`}
            meta={[
              {
                name: "description",
                content: _.truncate(faculty.Biography, { length: 156 }),
              },
            ]}
          />
        )}
        <div className="profile">
          <div className="profile__left">
            <div
              className={`lazyload profile__image${
                faculty.image ? " profile__image--with-photo" : ""
              }`}
              data-bg={SbImageService(faculty.image || avatar)}
              style={
                isSvg(faculty.image || avatar)
                  ? { backgroundImage: `url("${faculty.image || avatar}")` }
                  : null
              }
            />
          </div>
          <div className="profile__info card card--pd-md">
            <header className="profile__header">
              <div className="profile__header-intro">
                <h1 className="profile__heading heading heading--accent">
                  {faculty.FirstName || faculty.LastName
                    ? `${faculty.FirstName} ${faculty.LastName}`
                    : "Faculty Not Found"}
                </h1>
                {faculty.Campus && (
                  <p className="profile__location">{faculty.Campus}</p>
                )}
              </div>
              {faculty.LinkedIn && (
                <div className="profile__header-social">
                  <a
                    href={faculty.LinkedIn}
                    title={`${faculty.FirstName} ${faculty.LastName}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Icon.Linkedin className="icon icon--sm" />
                  </a>
                </div>
              )}
            </header>
            {faculty.PublishBio && faculty.PublishBio.length > 0 && (
              <section className="profile__section">
                <h2 className="profile__section-heading">Programs</h2>
                <div className="profile__tag-group">
                  {faculty.PublishBio.map((p) => (
                    <Tag
                      key={_.uniqueId(p)}
                      className="profile__tag"
                      label={p}
                    />
                  ))}
                </div>
              </section>
            )}
            {faculty.Biography && (
              <section className="profile__section">
                <h2 className="profile__section-heading">Bio</h2>
                <p>
                  <pre className="profile__section-pre">
                    {faculty.Biography}
                  </pre>
                </p>
              </section>
            )}
            {faculty.Publications && faculty.Publications.length > 0 && (
              <section className="profile__section">
                <h2 className="profile__section-heading">Publications</h2>
                <ul>
                  {faculty.Publications.map((pub) => (
                    <li key={pub.Id}>
                      {pub.Link ? (
                        <a href={pub.Link}>{pub.Title}</a>
                      ) : (
                        pub.Title
                      )}
                    </li>
                  ))}
                </ul>
              </section>
            )}
          </div>
        </div>
      </>
    )
  }
}

export default Profile
